export type MarginModeForCap = 'Isolated' | 'Cross';

/**
 * Effective isolated ceiling = min(crossMax, isolatedCap).
 * Field absent / null / undefined ⇒ no extra cap (returns crossMax).
 */
export function getEffectiveIsolatedMax(crossMax: number, isolatedCap: number | undefined | null): number {
  if (isolatedCap == null) return crossMax;
  return Math.min(crossMax, isolatedCap);
}

export function ceilingsDiffer(crossMax: number, effectiveIsolatedMax: number): boolean {
  return crossMax !== effectiveIsolatedMax;
}

export function getModeMaxLeverage(mode: MarginModeForCap, crossMax: number, effectiveIsolatedMax: number): number {
  return mode === 'Isolated' ? effectiveIsolatedMax : crossMax;
}

/**
 * Symbol/market Max chip (master §8):
 * - number = max(cross, effectiveIsolated) (= crossMax under product invariant)
 * - "Max" prefix only when ceilingsDiffer; otherwise legacy "{n}x"
 */
export function getSymbolMaxLeverageChip(
  crossMax: number,
  isolatedCap?: number | null,
): { leverage: number; withMaxPrefix: boolean } {
  const effectiveIsolatedMax = getEffectiveIsolatedMax(crossMax, isolatedCap);
  return {
    leverage: Math.max(crossMax, effectiveIsolatedMax),
    withMaxPrefix: ceilingsDiffer(crossMax, effectiveIsolatedMax),
  };
}
